/* globals jQuery, searchData */
jQuery(function ($) {
  $('#non-js-submit').hide()
  var request = null
  $('.search .sidebar.ajax input').change(function () {
    var searchParams = getSearchParameters()
    if ($('.loading-alert').length === 0) {
      $('.search-results-organic').prepend('<h3 class="loading-alert">Loading...</h3>')
    }
    request = $.ajax({
      url: searchData.endpoint,
      method: 'GET',
      data: searchParams,
      dataType: 'json',
      beforeSend: function () {
        if (request !== null) {
          request.abort()
        }
      }
    })
    request.done(function (response) {
      updateResultsContentSuccess(response)
      request = null
    })
    request.fail(function (response, exception) {
      if (response.statusText !== 'abort') {
        updateResultsContentFailure()
      }
      request = null
    })
    return false
  })

  function getSearchParameters () {
    var searchTerm = getSearchTerm()
    var contentTypes = getSelectedContentTypes()
    var dateValues = getDateValues()
    var orderBy = getOrderBy()
    var searchParams = $.extend({}, searchTerm, contentTypes, dateValues, orderBy)
    return searchParams
  }

  function updateResultsContentSuccess (response) {
    $('.search-results-organic').html(response.results)
  }

  function updateResultsContentFailure () {
    $('.search-results-organic').html('<h3>Sorry, something went wrong.</h3><p>Please try your search again</p>')
  }

  function getSelectedContentTypes () {
    var contentTypes = [
      'news',
      'blogs',
      'publications',
      'pages',
      'documents'
    ]
    var contentTypeValues = {}
    contentTypes.forEach(function (contentType) {
      if ($('#' + contentType).is(':checked')) {
        contentTypeValues[contentType] = $('#' + contentType).val()
      } else {
        contentTypeValues[contentType] = ''
      }
    })
    return contentTypeValues
  }

  function getDateValues () {
    var dateFilters = [
      'date-before',
      'date-after'
    ]
    var dateValues = {}
    dateFilters.forEach(function (dateFilter) {
      dateValues[dateFilter] = $('#' + dateFilter).val()
    })
    return dateValues
  }

  function getOrderBy () {
    var orderBy = {}
    orderBy['order-by'] = $('.search aside.sidebar input:radio[name="order-by"]:checked').val()
    return orderBy
  }

  function getSearchTerm () {
    var searchTerm = {}
    searchTerm['s'] = searchData.query
    return searchTerm
  }
})
